import EfImg from '@elem/ui/ef-img';
import { useReferralStore } from '../../ReferralProvider';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Introduction() {
    const { t } = useLang('referral.intrdocution');
    const { pageUsing } = useReferralStore();

    return (
        <div className={styles.Introduction}>
            <div className="introd-content">
                <div className="introd-img">
                    {pageUsing === 'd3ms' ? (
                        <EfImg
                            pc="https://websiteoss.ecoflow.com/figma-uploads/1761562270540-du2ynb-compressed-02_PC.jpg"
                            h5="https://websiteoss.ecoflow.com/figma-uploads/1761562285517-6ud60m-compressed-02_M.jpg"
                        />
                    ) : (
                        <EfImg
                            pc={'https://websiteoss.ecoflow.com/upload/image/1748349286473/introd_pc.jpg'}
                            pad={'https://websiteoss.ecoflow.com/upload/image/1748349289483/introd_h5.jpg'}
                            h5={'https://websiteoss.ecoflow.com/upload/image/1748349289483/introd_h5.jpg'}
                        />
                    )}
                </div>
                <div className="introd-title">
                    {t.rich('title', {
                        light: (text: string) => <span className="light">{text}</span>,
                    })}
                </div>
            </div>
        </div>
    );
}
